import { sniff } from '@/util'

// 控制 statusBar
const setStatusBar = function (theme = 'light') {
  if (sniff.isUboxAndroidApp) {
    window.app?.setStatusBar && window.app?.setStatusBar(theme)
  } else if (sniff.isUboxIosApp) {
    window?.webkit?.messageHandlers?.setStatusBar && window?.webkit?.messageHandlers?.setStatusBar.postMessage(theme)
  }
}

export default setStatusBar